<template>
  <div
    class="sys-tooltip-wrapper"
    @mouseenter="show"
    @mouseleave="hide"
  >
    <slot name="activator" :on="{}" :attrs="{}"></slot>
    <transition name="fade">
      <div
        v-if="isVisible && !disabled"
        class="sys-tooltip-content"
        :class="positionClass"
      >
        <div v-if="title" class="sys-tooltip-title">{{ title }}</div>
        <div class="sys-tooltip-text">{{ text }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SysTooltip',
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    positionClass() {
      if (this.bottom) return 'sys-tooltip-bottom';
      if (this.left) return 'sys-tooltip-left';
      if (this.right) return 'sys-tooltip-right';
      return 'sys-tooltip-top'; // Default to top
    },
  },
  methods: {
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.sys-tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.sys-tooltip-content {
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  border: 1px solid #e0e0e0;
  min-width: 200px;
  max-width: 280px;
  text-align: left;
}

.sys-tooltip-title {
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin-bottom: 4px;
  line-height: 1.4;
}

.sys-tooltip-text {
  font-size: 13px;
  color: #666666;
  line-height: 1.4;
  white-space: normal; /* Allow text wrapping */
}

/* Positioning */
.sys-tooltip-top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
}

.sys-tooltip-bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
}

.sys-tooltip-left {
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 8px;
}

.sys-tooltip-right {
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  margin-left: 8px;
}

/* Transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
